import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import Popover from '@/shared/components/popover/index.vue';
import store from '@/trust-atcs-app/store';
import { PopoverView } from '@/shared/components/popover/popover';
import CurrencyInput from '@/shared/components/currency-input/index.vue';

@Options({
  components: {
    Popover,
    CurrencyInput,
  }
})
export default class InputTextNumberCurrency extends Vue {

  @Prop()
  private question!: any;

  @Prop()
  private questionTypeId!: number;

  private uniqueIdName = null as any;
  private selectedOption = null as any;
  private newWording = '';
  private obj: PopoverView = null as any;
  private subQuestionAnswers: any[] = [];

  created(): void {
    this.initField();
    const content = store.getters.getPopovers;
    this.newWording = this.question.wording;
    if (this.question.wording.match(/--{{([^)]+)}}--/)) {
      const popovers = this.question.wording.match(/--{{([^)]+)}}--/)[1];
      this.obj = content.filter((x: any) => x.key == popovers)[0];
      this.newWording = this.question.wording.replace('--{{' + popovers + '}}--', '');
    }
  }

  private initField(): void {
    //
  }

  mounted(): void {
    this.validForm();
  }

  private validForm(): boolean {
    let valid = false;
    switch (this.questionTypeId) {
      case 2:
        valid = this.question.responses[0].answerTxt !== null && this.question.responses[0].answerTxt !== '';
        break;
      case 3:
        valid = this.question.responses[0].answerNumber !== null && this.question.responses[0].answerNumber >= 0 && (this.question.responses[0].answerNumber).toString() !== '';
        break;
      case 5:
        valid = this.question.responses[0].answerCurrency !== null && this.question.responses[0].answerCurrency >= 0;
        break;
    }
    this.$emit('validForm', valid);
    return valid;
  }

}


